export const BR_EMAIL = "info@barerock.group";

export const letters = [
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
];

export const submitLoadingMessage =
  "Please wait…. Submitting your application, don’t refresh the page.";

export const loadingGenericMessage =
  "Please wait…. Processing your request, don’t refresh the page.";

export const barerockUrl = "https://apply.barerock.group/";

export const requiredAnswerMessage =
  "Please answer all required questions/fields or use skip for now";

export const errorMessage =
  "We've encountered an unexpected hiccup. Try refreshing your page to try again.";

export const mtaCodes = {
  address: "MTA0001",
  companyName: "MTA0002",
  policyTermLength: "MTA0003",
  natureOfBusiness: "MTA0004",
  insuredName: "MTA0005",
  dbIntroducer: "MTA0006",
  runOff: "MTA0007",
  cancelPolicy: "MTA0008",
  others: "MTA0009",
};

export const mtaMessages = {
  [mtaCodes.address]: "Please enter the new address below.",
  [mtaCodes.companyName]: "Enter your new company name.",
  [mtaCodes.policyTermLength]:
    "Please tell us why you would like to extend the length of your policy with BareRock.",
  [mtaCodes.natureOfBusiness]:
    "What adjustment would you like to make to your policy?",
  [mtaCodes.insuredName]:
    "Enter the name of the business being added to to the policy.",
  [mtaCodes.dbIntroducer]: "Please provide details about the the DB Introducer",
  [mtaCodes.runOff]: "Please provide details about the Runoff below.",
  [mtaCodes.cancelPolicy]:
    "Please tell us why you would like to cancel your policy with BareRock",
  [mtaCodes.others]: "What adjustment would you like to make to your policy?",
};

export const mtaRequiredMessages = {
  type: "Mta type is required",
  date: "Effective date is required",
};

export const allPermissions = {
  CAN_ACCEPT_DECLINE_QUOTE: "can_accept_decline_quote",
  CAN_BIND_QUOTE: "can_bind_quote",
  CAN_DELEGATE_APPLICATION: "can_delegate_application",
  CAN_EDIT_APPLICATION: "can_edit_application",
  CAN_MANAGE_USERS: "can_manage_users",
  CAN_NOTIFY_CLAIM: "can_notify_claim",
  CAN_PAY_PREMIUM: "can_pay_premium",
  CAN_RENEW: "can_renew",
  CAN_START_APPLICATION: "can_start_application",
  CAN_SUBMIT_APPLICATION: "can_submit_application",
  CAN_VIEW_APPLICATION: "can_view_application",
  CAN_VIEW_CLAIMS: "can_view_claims",
  CAN_VIEW_POLICY: "can_view_policy",
  CAN_VIEW_QUOTE: "can_view_quote",
  CAN_VIEW_USERS: "can_view_users",
};

export const DEBOUNCE_TIME = 1000;
export const thirdPartyPayerReasons = [
  "Cash flow due to temporary financial constraints",
  "Use of a personal account by a sole proprietor",
  "Payment through an associated company or subsidiary",
  "Error in accounting or payment processing",
  "Use of a holding company",
  "Transitional period during business restructuring",
  "Other",
];

export const customerRelations = ["CST", "PRT"];

export const thirdPartyPayerRelationships = [
  "Director or proprietor’s personal account",
  "Group or Holding Company account",
  "Subsidiary Company account",
  "Associated company account",
  "Other",
];

export const imageTypes = [
  "JPEG",
  "jpeg",
  "jpg",
  "JPG",
  "PNG",
  "png",
  "GIF",
  "gif",
  "SVG",
  "svg",
  "WebP",
  "webp",
];

export const subStages = {
  submitted: "SUB",
  referred: "REF",
  inProgress: "INP",
  started: "STA",
  issued: "ISD",
  issuedWithSubjectivities: "QIS",
  takenUp: "QTP",
  declinedToQuote: "DEC",
  bound: "BND",
  notTakenUp: "QNT",
  quoted: "QUO",
  policyIssued: "PIL",
  policyCancelled: "CAN",
  policyRenewed: "PRD",
};

export const emailType = ["msg", "eml"];

export const videoTypes = [
  "mp4",
  "MP4",
  "avi",
  "AVI",
  "mov",
  "MOV",
  "wmv",
  "WMV",
  "flv",
  "FLV",
  "mkv",
  "MKV",
  "webm",
  "WEBM",
  "m4v",
  "M4V",
  "3gp",
  "3GP",
  "ogg",
  "OGG",
];

// issued live, Cancelled
export const currentPoliciesStatus = ["PIL", "CAN"];

// policy expired, policy lapsed, policy Renewed
export const previousPoliciesStatus = ["PED", "PLD", "PRD"];

export const serverErrorMessage =
  "Our service is temporarily unavailable due to maintenance downtime or technical difficulty.";

export const renewPolicyValidationMessage =
  "A policy update is currently in progress. To ensure your renewal includes all recent changes, please wait until this update is complete before starting your renewal process.";

export const customerRelationStatus = {
  Broker: {
    code: "BRK",
    name: "Broker",
  },
  Insurer: {
    code: "INS",
    name: "Insurer",
  },
  MGA: {
    code: "MGA",
    name: "MGA/Coverholder",
  },
  TPA: {
    code: "TPA",
    name: "Third Party Administrator ",
  },
  Other: {
    code: "OTH",
    name: "Other",
  },
  Prospect: {
    code: "PRT",
    name: "Prospect",
  },
  Customer: {
    code: "CST",
    name: "Customer",
  },
  Supplier: {
    code: "SUP",
    name: "Supplier",
  },
  ThirdParty: {
    code: "3PT",
    name: "Third Party",
  },
};

export const clientsTableFields =
  "id,name,business_type,relationship,created_at,fca_number,ch_number,company_approval_status,customer_segmentation,is_active";

const loggedInUserData = JSON.parse(sessionStorage.getItem("loggedUserData"));
const customerRelationCode =
  loggedInUserData?.user_data?.customer_relation?.code;
export const isCustomer = customerRelationCode
  ? customerRelations.includes(customerRelationCode)
  : null;

export const carrierTypeOptions = [
  { id: "Syndicate", value: "Syndicate" },
  { id: "Company", value: "Company" },
  { id: "Reinsurer", value: "Reinsurer" },
  { id: "Other", value: "Other" },
];

export const brokerTypeOptions = [
  { id: "Retail", value: "Retail" },
  { id: "Wholesale", value: "Wholesale" },
  { id: "Reinsurance", value: "Reinsurance" },
];
